import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Apollo } from 'apollo-angular';

import { add_committee_link } from './graphql/addCommitteeLink';
import { update_committee_link } from './graphql/updateCommitteeLink';
import { delete_committee_link } from './graphql/deleteCommitteeLink';
import Milestone from 'src/app/interfaces/milestone';
import ID from 'src/app/types/id';
import {ActivatedRoute} from "@angular/router";

const ADD_COMMITTEE_LINK = add_committee_link;
const UPDATE_COMMITTEE_LINK = update_committee_link;
const DELETE_COMMITTEE_LINK = delete_committee_link;

@Component({
    selector: 'app-committee-links',
    templateUrl: './committee-links.component.html',
    styleUrls: ['./committee-links.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CommitteeLinksComponent implements OnInit {
  @Input() deal: any;
  @Input() milestones: Milestone[];
  @Input() dashboardType: string = "committee";
  @Input() readOnly: boolean;

  waiting: boolean = false;
  shouldExpand: boolean = true;
  constructor(private apollo: Apollo, private route: ActivatedRoute) {}

  ngOnInit(): void {
    if (this.deal.committeeLinks.length > 0) {
      let linkarr = [];
      for (let i = 0; i < this.deal.committeeLinks.length; i++) {
        linkarr.push({
          ...this.deal.committeeLinks[i],
          milestone_id: this.deal.committeeLinks[i].milestone_id
            ? this.deal.committeeLinks[i].milestone_id
            : -1,
          copy: this.deal.committeeLinks[i],
          editMode: false,
        });
      }
      this.deal.committeeLinks = linkarr;
    } else {
      this.deal.committeeLinks = [];
    }
    if(this.dashboardType=='closing'){
      this.shouldExpand = false;
    }
  }

  addLink() {
    this.deal.committeeLinks.push({
      id: 'new',
      name: '',
      url: '',
      editMode: true,
      milestone_id: null,
      copy: {
        id: 'new',
        name: '',
        url: '',
        milestone_id: null,
      },
    });
  }
  updateLink(link: any, index: number) {
    link.editMode = !link.editMode;
    if (
      link.editMode === false &&
      !(
        link.name === link.copy.name &&
        link.url === link.copy.url &&
        link.milestone_id === link.copy.milestone_id
      )
    ) {
      let callType: any;
      let callVar: any;
      if (link.id === 'new') {
        callType = ADD_COMMITTEE_LINK;
        callVar = {
          input: {
            project_id: this.deal.projectid,
            name: link.name,
            url: link.url,
            milestone_id:
              link.milestone_id === -1 || !link.milestone_id
                ? null
                : link.milestone_id,
            is_package:
              link.milestone_id !== null && link.milestone_id.length > 0,
          },
        };
      } else {
        callType = UPDATE_COMMITTEE_LINK;
        callVar = {
          input: {
            id: link.id,
            name: link.name,
            url: link.url,
            milestone_id: link.milestone_id !== -1 ? link.milestone_id : null,
            is_package:
              link.milestone_id !== null && link.milestone_id.length > 0,
          },
        };
      }
      this.waiting = true;
      let sub = this.apollo
        .mutate({
          mutation: callType,
          variables: callVar,
        })
        .subscribe(
          ({ data }) => {
            this.waiting = false;
            let obj: any = data;
            if (this.deal.committeeLinks[index].id === 'new') {
              this.deal.committeeLinks[index] = {
                ...obj.addCommitteeLink,
                milestone_id:
                  obj.addCommitteeLink.milestone_id === null
                    ? -1
                    : obj.addCommitteeLink.milestone_id,
                copy: {
                  ...obj.addCommitteeLink,
                  milestone_id:
                    obj.addCommitteeLink.milestone_id === null
                      ? -1
                      : obj.addCommitteeLink.milestone_id,
                },
                editMode: false,
              };
            } else {
              this.deal.committeeLinks[index] = {
                ...obj.updateCommitteeLink,
                milestone_id:
                  obj.updateCommitteeLink.milestone_id === null
                    ? -1
                    : obj.updateCommitteeLink.milestone_id,
                copy: {
                  ...obj.updateCommitteeLink,
                  milestone_id:
                    obj.updateCommitteeLink.milestone_id === null
                      ? -1
                      : obj.updateCommitteeLink.milestone_id,
                },
                editMode: false,
              };
            }
            this.deal.committeeLinks.sort((a: any, b: any) =>
              a.name.localeCompare(b.name)
            );
            sub && sub.unsubscribe();
          },
          (error) => {
            this.waiting = false;
            this.deal.committeeLinks[index].name =
              this.deal.committeeLinks[index].copy.name;
            this.deal.committeeLinks[index].url =
              this.deal.committeeLinks[index].copy.url;
            this.deal.committeeLinks[index].editMode =
              this.deal.committeeLinks[index].id === 'new';
            sub && sub.unsubscribe();
          }
        );
    }
  }
  getMilestoneLabel(milestoneId: ID): string {
    let milestone: Milestone | undefined = this.milestones.find(
      (m: Milestone) => m.id === milestoneId
    );
    if (milestone) {
      let nameArray = milestone.name.split(' ');
      return `${nameArray[0]} Package`;
    }
    return 'Unknown Package';
  }
  deleteLink(link: any, index: number) {
    if (link.id !== 'new') {
      this.waiting = true;
      let sub = this.apollo
        .mutate({
          mutation: DELETE_COMMITTEE_LINK,
          variables: {
            id: link.id,
          },
        })
        .subscribe(
          ({ data }) => {
            this.waiting = false;
            this.deal.committeeLinks.splice(index, 1);
            sub && sub.unsubscribe();
          },
          (error) => {
            this.waiting = false;
            sub && sub.unsubscribe();
          }
        );
    } else {
      this.deal.committeeLinks.splice(index, 1);
    }
  }

  navigateToClosingDashboard(){
    let url = location.origin + `/deal/closing/${this.deal.projectid}`;
    window.open(url, '_blank')
  }

  goTo(link: string) {
    if (!(link.startsWith('http://') || link.startsWith('https://'))) {
      link = 'https://' + link;
    }
    window.open(link, '_blank');
  }
}
